<div class="latency-block">
  @if (latency$ | async; as latency) {
    <p [style.color]="latency >= 150 ? 'red' : 'green'">{{ latency | number: '1.0-0' }} ms</p>
  } @else {
    <p>Calculating latency...</p>
  }
</div>
